import { Injectable } from '@angular/core';
import { SocketBaseHandlerService } from 'src/app/services/common/socket-base-handler.service';
import { SocketMessage } from './canvas.model';

@Injectable()
export class ChatSocketService extends SocketBaseHandlerService<SocketMessage> {
  forceClearConnection(): void {
    this.disconnect();
  }
}
